"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EARTH_FLATTENING = exports.EARTH_AXIS_RATIO = exports.EARTH_RADIUS = void 0;
exports.EARTH_RADIUS = 6378137;
exports.EARTH_AXIS_RATIO = 0.996647189335;
exports.EARTH_FLATTENING = 1 - exports.EARTH_AXIS_RATIO;
